import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { extractError } from "../lib/formatError";
import { AuthShell, TextField } from "./Signup";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (pw !== confirm) {
      setError("Passwords do not match");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => nav("/login", { replace: true }), 1500);
    } catch (e2) {
      setError(extractError(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Reset password" subtitle="Pick a new one" testid="reset-password-page">
      {done ? (
        <div data-testid="reset-done">
          <div className="text-[color:var(--gold)] font-display italic text-2xl mb-2">Password updated.</div>
          <p className="text-sm text-[color:var(--muted)]">Redirecting to log in…</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <TextField label="New password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} testid="reset-password" required />
          <TextField label="Confirm password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} testid="reset-confirm" required />
          {error && (
            <div className="text-xs text-[color:var(--red)] border border-[color:var(--red)] px-3 py-2" data-testid="reset-error">
              {error}
            </div>
          )}
          <button type="submit" disabled={busy || !token} className="spin-btn w-full" data-testid="reset-submit-btn">
            {busy ? "Saving…" : "Set new password"}
          </button>
          <div className="text-center text-xs text-[color:var(--muted)]">
            <Link to="/login" className="text-[color:var(--gold)]">Back to log in</Link>
          </div>
        </form>
      )}
    </AuthShell>
  );
}
